import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import TableHeader from 'modules/_shared/Table/components/TableHeader';
import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';

const RenumerationOperationTableHeader: FC = () => {
  const { t } = useTranslate();

  const columns = [
    { key: 'expand', content: '' }, // empty header for expand button column
    { key: 'partner', content: t('Partner') },
    { key: 'class', content: t('Class') },
    { key: 'from', content: t('From') },
    { key: 'to', content: t('To') },
    { key: 'totalShares', content: t('TotalShares') },
  ].filter(Boolean) as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default RenumerationOperationTableHeader;
